"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultsTable = ResultsTable;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _formik = require("formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable prettier/prettier */

function ResultsTable(_ref) {
  var {
    apiResults
  } = _ref;
  var {
    values
  } = (0, _formik.useFormikContext)();
  var {
    year,
    age,
    benefit_base_MM_growth_0,
    withdrawal_rate_MM_growth_0,
    annual_lifetime_benefit_amount_MM_growth_0,
    benefit_base_competitor_growth_0,
    withdrawal_rate_competitor_growth_0,
    annual_lifetime_benefit_amount_competitor_growth_0,
    benefit_base_MM_growth_x,
    withdrawal_rate_MM_growth_x,
    annual_lifetime_benefit_amount_MM_growth_x,
    benefit_base_competitor_growth_x,
    withdrawal_rate_competitor_growth_x,
    annual_lifetime_benefit_amount_competitor_growth_x
  } = apiResults;
  var rowCount = year.length;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "table-sticky",
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, {
    tableCaption: "GLWB SimpleTable Test Caption"
  }, /*#__PURE__*/_react.default.createElement("thead", {
    className: "head-sticky-top"
  }, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 2,
    className: "glwb-table-sticky cell-border-right",
    id: "blankcell-header-a"
  }, "\xA0"), /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 6,
    className: "main-header-row cell-border-right"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "table-text-style"
  }, "Income with an assumed market growth of", ' ', values.net_market_growth_rate)), /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 6,
    className: "main-header-row"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Guaranteed income with an assumed market growth of 0% "))), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 2,
    className: "glwb-table-sticky cell-border-right cell-border-bottom",
    id: "blankcell-header-b"
  }, "\xA0"), /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 3,
    className: "sub-head-1 cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " MassMutual RetirePay ")), /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 3,
    className: "sub-head-2 cell-border-bottom cell-border-right"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Competitor GLWB ")), /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 3,
    className: "sub-head-1 cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " MassMutual RetirePay ")), /*#__PURE__*/_react.default.createElement("th", {
    colSpan: 3,
    className: "sub-head-2 cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Competitor GLWB "))), /*#__PURE__*/_react.default.createElement("tr", {
    className: "cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-1",
    className: "glwb-table-sticky cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Year ")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-2",
    className: "glwb-table-sticky cell-border-bottom cell-border-right"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " Age ")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-3",
    className: "cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Benefit Base "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdwow-header-4",
    className: "cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Withdrawal Rate "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-5",
    className: "cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Annual Lifetime Benefit Amount "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-6",
    className: "gray-background cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Benefit Base "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-7",
    className: "gray-background cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " Withdrawal Rate "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-8",
    className: "gray-background cell-border-right cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Benefit Amount "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-9",
    className: "cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Benefit Base "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-10",
    className: "cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " Withdrawal Rate "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-11",
    className: "cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Annual Lifetime Benefit Amount"))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-12",
    className: "gray-background cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " Benefit Base "))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-13",
    className: "gray-background cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-small-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Withdrawal Rate"))), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdrow-header-14",
    className: "gray-background cell-border-bottom"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glwb-table-col-resized"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Benefit Amount "))))), /*#__PURE__*/_react.default.createElement("tbody", {
    tabIndex: "0"
  }, Array.from({
    length: rowCount
  }, (_, rowIndex) => {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: rowIndex
    }, /*#__PURE__*/_react.default.createElement("td", null, " ", year[rowIndex]), /*#__PURE__*/_react.default.createElement("td", {
      className: "cell-border-right"
    }, age[rowIndex]), /*#__PURE__*/_react.default.createElement("td", null, benefit_base_MM_growth_x[rowIndex]), /*#__PURE__*/_react.default.createElement("td", null, withdrawal_rate_MM_growth_x[rowIndex]), /*#__PURE__*/_react.default.createElement("td", null, annual_lifetime_benefit_amount_MM_growth_x[rowIndex]), /*#__PURE__*/_react.default.createElement("td", {
      className: "gray-background "
    }, benefit_base_competitor_growth_x[rowIndex]), /*#__PURE__*/_react.default.createElement("td", {
      className: "gray-background"
    }, ' ', withdrawal_rate_competitor_growth_x[rowIndex]), /*#__PURE__*/_react.default.createElement("td", {
      className: "gray-background cell-border-right"
    }, annual_lifetime_benefit_amount_competitor_growth_x[rowIndex]), /*#__PURE__*/_react.default.createElement("td", null, benefit_base_MM_growth_0[rowIndex]), /*#__PURE__*/_react.default.createElement("td", null, withdrawal_rate_MM_growth_0[rowIndex]), /*#__PURE__*/_react.default.createElement("td", null, annual_lifetime_benefit_amount_MM_growth_0[rowIndex]), /*#__PURE__*/_react.default.createElement("td", {
      className: "gray-background"
    }, benefit_base_competitor_growth_0[rowIndex]), /*#__PURE__*/_react.default.createElement("td", {
      className: "gray-background"
    }, withdrawal_rate_competitor_growth_0[rowIndex]), /*#__PURE__*/_react.default.createElement("td", {
      className: "gray-background"
    }, annual_lifetime_benefit_amount_competitor_growth_0[rowIndex]));
  })))));
}